<template>
  <div>
    <div class="wrapper">
      <div class="window" v-for="stat in stats" :key="stat.label">
        <div class="text">
          <h1>{{ stat.label }}</h1>
          <p>{{ stat.value }}</p>
        </div>
        <div class="stat-wrapper">
          <Chart :label="stat.label"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "@/components/Chart.vue";

export default {
  name: "Statistics",
  components: {
    Chart
  },
  data() {
    return {
      stats: [
        {
          label: "Polubienia",
          value: 36224
        },
        {
          label: "Komentarze",
          value: 1024
        },
        {
          label: "Obserwujący",
          value: 5235
        },
        {
          label: "Obserwowani",
          value: 3253
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  max-height: calc(100%);
  @media only screen and (max-width: 480px) {
    max-height: calc(100%);
  }
}

.window {
  background-color: rgba(255, 255, 255, 0.05);
  width: 96%;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  box-sizing: border-box;
  padding: 20px;
  margin: 15px 2% 0 2%;
  border-radius: 10px;
  &:last-child {
    margin: 15px 0 15px 2%;
  }
  .text {
    @media only screen and (min-width: 768px) {
      float: left;
      margin: 50px 15px;
    }
    h1 {
      margin: 0;
      font-size: 20px;
    }
    p {
      margin: 5px;
      font-size: 30px;
    }
  }
}

.stat-wrapper {
  padding: 0;
  @media only screen and (min-width: 480px) {
    padding-left: 15px;
  }
  display: flex;
  box-sizing: border-box;
}

h1 {
  margin: 40vh auto;
  cursor: default;
}
</style>
